import { render, staticRenderFns } from "./QuickLogistic.vue?vue&type=template&id=a8046d36&scoped=true&"
import script from "./QuickLogistic.vue?vue&type=script&lang=js&"
export * from "./QuickLogistic.vue?vue&type=script&lang=js&"
import style0 from "./QuickLogistic.vue?vue&type=style&index=0&id=a8046d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8046d36",
  null
  
)

export default component.exports